import axios from 'axios';
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

interface CardData{
	card_number: string,
	holder_name: string,
	expiration_year: string,
	expiration_month: string,
	cvv2: string,
	postal_code: string,
}

interface TokenData{
	live: boolean,
	token: string,
	device_fingerprint: string,
}

const OPENPAY_URL = {
	live: 'https://api.openpay.mx/v1/',
	sandbox: 'https://sandbox-api.openpay.mx/v1/',
	script_url: 'https://js.openpay.mx/openpay-data.v1.min.js',
}
var useOpenpay = ()=>{
	var [loadedScript, setLoadedScript] = useState<boolean>(false);

	var loadScript = ()=>{
		if(loadedScript) return;
		(window as any).OpenPay = {};
		const script = document.createElement('script');
		script.src = OPENPAY_URL.script_url;
		script.async = true;
		document.body.appendChild(script);
		setLoadedScript(true);
	}

	var getDeviceFingerprint = (merchant_id: string) : string=>{
		if((window as any).OpenPay && (window as any).OpenPay.deviceData){
			(window as any).OpenPay.getId = ()=>{
				return merchant_id;
			}
			return (window as any).OpenPay.deviceData.setup();
		}
		return null;
	}

	var createToken = async (merchant_id: string, public_key: string, card_data: CardData, live: boolean=true) : Promise<TokenData>=>{
		try{
			loadScript();
		}catch(e){}
		try{
			var res = await axios.post<{
				id: string,
				card: CardData,
			}>(`${OPENPAY_URL[live ? 'live' : 'sandbox']}${merchant_id}/tokens`, card_data, {
				headers: {
					'Authorization': `Bearer ${btoa(public_key+':')}`
				}
			});
			var device_token = getDeviceFingerprint(merchant_id);

			return {
				device_fingerprint: device_token,
				live,
				token: res.data.id,
			}
		}catch(e){
			throw e;
		}
	}

	return {
		createToken,
	}
}

export default useOpenpay;